import React from 'react'
import styled from 'styled-components'
import { get } from 'lodash'

import { Loader } from '../icons/Loader'
import { theme } from '../../constants/theme'

import { Label, Body } from './Typography'
import { Trad } from './Trad'
import { Margin } from './Margin'
import { Button } from './Button'
import { Link } from './Link'

export const List = ({
  listRequest, // used to plug a request directly to the list
  columnTitles, displayItem, // display props
  getRowLink,
  customColor,
  ...props
}) => {
  const info = listRequest.state.data || {}
  const items = get(listRequest, 'state.data.docs')

  return (
    <>
      {listRequest.state.success && (
        <PageInfo>
          {info.totalDocs}
          {' '}
          <Trad id="results" />
          {info.totalPages > 1 && (
            <>
              {' - '}
              <Trad id="page" />
              {' '}
              {info.page}
              {' '}
              <Trad id="pageXOn" />
              {' '}
              {info.totalPages}
              <Margin h={10} />
              <PageButton disabled={info.page === 1} onClick={() => listRequest.setPage(info.prevPage)}>‹</PageButton>
              <Margin h={10} />
              <PageButton
                disabled={info.page === info.totalPages}
                onClick={() => listRequest.setPage(info.nextPage)}
              >
                ›
              </PageButton>
            </>
          )}
        </PageInfo>
      )}
      <div>
        <Header>
          {columnTitles.map(({
            title, size, upper, content,
          }, index) => (
            <Cell key={title || index} columnNumber={columnTitles.length} size={size}>
              {content || <Label tradId={title} upper={upper} />}
            </Cell>
          ))}
        </Header>

        {listRequest.state.loading ? (
          <LoaderWrapper>
            <Loader height={50} />
            {' '}
          </LoaderWrapper>
        ) : !get(items, 'length') ? <Trad id="noResult" /> : (items).map((item, index) => {
          const line = (
            <Line key={item.id || index} isLink={getRowLink} customColor={customColor ? customColor(item) : undefined}>
              {displayItem(item, props).map((content, i) => (
                <Cell columnNumber={columnTitles.length} key={i} size={columnTitles[i].size}>
                  {typeof content === 'object'
                    ? (content.content ? content.content : '-')
                    : content}
                </Cell>
              ))}
            </Line>
          )

          return getRowLink ? <Link key={item.id || index} to={getRowLink(item)}>{line}</Link> : line
        })}

      </div>
    </>

  )
}

const Line = styled.div`
  display: flex;
  padding: 0 10px;
  margin: 10px 0px;
  min-height: 80px;
  align-items: center;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  ${({ isLink }) => (isLink ? `
    &:hover{
      background: ${theme.colors.bodyGray};
    }
  ` : '')}
  background: ${({ customColor }) => (customColor || theme.colors.white)};
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  @media (max-width: 1000px) {
    font-size: 13px;
  }
  @media (min-width: 1000px) and (max-width: 1250px)  {
    font-size: 15px;
  }
`

const Header = styled.div`
  display: flex;
  padding: 0 23px;
  margin: 20px 0;
  min-height: 50px;
  align-items: center;
  width: 100%;
  font-size: 18px;
  font-weight: 400;
  color: ${theme.colors.blueCommon};
  background-color: ${theme.colors.white};
  border-radius: 5px;
  filter: drop-shadow(0px 20px 100px rgba(0, 0, 0, 0.1));
  @media (max-width: 1000px) {
    display: none;
  }
`
const PageButton = styled(Button)`
  font-size: 30px;
  padding: 0;
  width: 25px;
  border: none;
  color: ${({ disabled }) => (disabled ? theme.colors.grayLight : theme.colors.grayDark)};
  background: ${theme.colors.white};
`


const Cell = styled.div`
  flex: ${({ size = 1 }) => size};
  @media (max-width: 1000px) {
    overflow-wrap: break-word;
    padding: 4px;
  }
`

const LoaderWrapper = styled.div`
  padding: 20px;
  text-align: center;
`

export const ListButtonWrapper = styled.div`
  display: flex;
  &>* { flex-shrink: 0 }
  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`

export const HiddenListButtonWrapper = styled(ListButtonWrapper)`
  visibility: hidden;
`

const PageInfo = styled(Body)`
  color: ${theme.colors.grayDark};
  margin: 10px 5px;
  float: right;
`
